{
    "information_for_contributors": [
      "The source of this file is https://github.com/JohnnyMorganz/Luau.tmLanguage/blob/main/Luau.YAML-tmLanguage",
      "If you want to provide a fix or improvement, please create a pull request against the original repository.",
      "Once accepted there, we are happy to receive an update request."
    ],
    "name": "Luau",
    "scopeName": "source.luau",
    "fileTypes": [
      "luau"
    ],
    "patterns": [
      {
        "include": "#function-definition"
      },
      {
        "include": "#number"
      },
      {
        "include": "#string"
      },
      {
        "include": "#comment"
      },
      {
        "include": "#local-declaration"
      },
      {
        "include": "#for-loop"
      },
      {
        "include": "#type-function"
      },
      {
        "include": "#type-alias-declaration"
      },
      {
        "include": "#keyword"
      },
      {
        "include": "#language_constant"
      },
      {
        "include": "#standard_library"
      },
      {
        "include": "#generics-instantiation"
      },
      {
        "include": "#identifier"
      },
      {
        "include": "#operator"
      },
      {
        "include": "#parentheses"
      },
      {
        "include": "#table"
      },
      {
        "include": "#type_cast"
      },
      {
        "include": "#type_annotation"
      },
      {
        "include": "#attribute"
      }
    ],
    "repository": {
      "function-definition": {
        "begin": "\\b(?:(local)\\s+|(const)\\s+)?(function)\\b(?![,:])",
        "beginCaptures": {
          "1": {
            "name": "storage.modifier.local.luau"
          },
          "2": {
            "name": "storage.modifier.const.luau"
          },
          "3": {
            "name": "keyword.control.luau"
          }
        },
        "end": "(?<=[\\)\\-{}\\[\\]\"'])",
        "name": "meta.function.luau",
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#generics-declaration"
          },
          {
            "begin": "(\\()",
            "beginCaptures": {
              "1": {
                "name": "punctuation.definition.parameters.begin.luau"
              }
            },
            "end": "(\\))",
            "endCaptures": {
              "1": {
                "name": "punctuation.definition.parameters.end.luau"
              }
            },
            "name": "meta.parameter.luau",
            "patterns": [
              {
                "include": "#comment"
              },
              {
                "match": "\\.\\.\\.",
                "name": "variable.parameter.function.varargs.luau"
              },
              {
                "match": "[a-zA-Z_][a-zA-Z0-9_]*",
                "name": "variable.parameter.function.luau"
              },
              {
                "match": ",",
                "name": "punctuation.separator.arguments.luau"
              },
              {
                "begin": ":",
                "beginCaptures": {
                  "0": {
                    "name": "keyword.operator.type.luau"
                  }
                },
                "end": "(?=[\\),])",
                "patterns": [
                  {
                    "include": "#type_literal"
                  }
                ]
              }
            ]
          },
          {
            "match": "\\b(__(?:add|call|concat|div|eq|index|le|len|lt|metatable|mod|mode|mul|newindex|pow|sub|tostring|unm|iter|idiv|tojson|jsonhint))\\b",
            "name": "variable.language.metamethod.luau"
          },
          {
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b",
            "name": "entity.name.function.luau"
          }
        ]
      },
      "local-declaration": {
        "begin": "\\b(local)\\b",
        "end": "(?=\\s*do\\b|\\s*[=;]|\\s*$)",
        "beginCaptures": {
          "1": {
            "name": "storage.modifier.local.luau"
          }
        },
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#attribute"
          },
          {
            "begin": "(:)",
            "beginCaptures": {
              "1": {
                "name": "keyword.operator.type.luau"
              }
            },
            "end": "(?=\\s*do\\b|\\s*[=;,]|\\s*$)",
            "patterns": [
              {
                "include": "#type_literal"
              }
            ]
          },
          {
            "name": "variable.other.constant.luau",
            "match": "\\b([A-Z_][A-Z0-9_]*)\\b"
          },
          {
            "name": "variable.other.readwrite.luau",
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b"
          }
        ]
      },
      "for-loop": {
        "begin": "\\b(for)\\b",
        "beginCaptures": {
          "1": {
            "name": "keyword.control.luau"
          }
        },
        "end": "\\b(in)\\b|(=)",
        "endCaptures": {
          "1": {
            "name": "keyword.control.luau"
          },
          "2": {
            "name": "keyword.operator.assignment.luau"
          }
        },
        "patterns": [
          {
            "begin": "(:)",
            "beginCaptures": {
              "1": {
                "name": "keyword.operator.type.luau"
              }
            },
            "end": "(?=\\s*in\\b|\\s*[=,]|\\s*$)",
            "patterns": [
              {
                "include": "#type_literal"
              }
            ]
          },
          {
            "name": "variable.parameter.luau",
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b"
          }
        ]
      },
      "string_escape": {
        "patterns": [
          {
            "name": "constant.character.escape.luau",
            "match": "\\\\[abfnrtvz'\"`{\\\\]"
          },
          {
            "name": "constant.character.escape.luau",
            "match": "\\\\\\d{1,3}"
          },
          {
            "name": "constant.character.escape.luau",
            "match": "\\\\x[0-9a-fA-F]{2}"
          },
          {
            "name": "constant.character.escape.luau",
            "match": "\\\\u\\{[0-9a-fA-F]*\\}"
          },
          {
            "name": "constant.character.escape.luau",
            "match": "\\\\$"
          }
        ]
      },
      "number": {
        "patterns": [
          {
            "name": "constant.numeric.hex.luau",
            "match": "\\b0_*[xX]_*[\\da-fA-F_]*(?:[eE][\\+\\-]?_*\\d[\\d_]*(?:\\.[\\d_]*)?)?"
          },
          {
            "name": "constant.numeric.binary.luau",
            "match": "\\b0_*[bB][01_]+(?:[eE][\\+\\-]?_*\\d[\\d_]*(?:\\.[\\d_]*)?)?"
          },
          {
            "name": "constant.numeric.decimal.luau",
            "match": "(?:\\d[\\d_]*(?:\\.[\\d_]*)?|\\.\\d[\\d_]*)(?:[eE][\\+\\-]?_*\\d[\\d_]*(?:\\.[\\d_]*)?)?"
          }
        ]
      },
      "string": {
        "patterns": [
          {
            "name": "string.quoted.double.luau",
            "begin": "\"",
            "end": "\"",
            "patterns": [
              {
                "include": "#string_escape"
              }
            ]
          },
          {
            "name": "string.quoted.single.luau",
            "begin": "'",
            "end": "'",
            "patterns": [
              {
                "include": "#string_escape"
              }
            ]
          },
          {
            "name": "string.other.multiline.luau",
            "begin": "\\[(=*)\\[",
            "end": "\\]\\1\\]"
          },
          {
            "name": "string.interpolated.luau",
            "begin": "`",
            "end": "`",
            "patterns": [
              {
                "include": "#interpolated_string_expression"
              },
              {
                "include": "#string_escape"
              }
            ]
          }
        ]
      },
      "interpolated_string_expression": {
        "name": "meta.template.expression.luau",
        "contentName": "meta.embedded.line.luau",
        "begin": "\\{",
        "end": "\\}",
        "beginCaptures": {
          "0": {
            "name": "punctuation.definition.interpolated-string-expression.begin.luau"
          }
        },
        "endCaptures": {
          "0": {
            "name": "punctuation.definition.interpolated-string-expression.end.luau"
          }
        },
        "patterns": [
          {
            "include": "source.luau"
          }
        ]
      },
      "standard_library": {
        "patterns": [
          {
            "name": "support.function.luau",
            "match": "(?<![^.]\\.|:)\\b(assert|dangerouslyexecuterequiredmodule|error|gcinfo|getmetatable|ipairs|newproxy|next|pairs|pcall|print|quaternion|rawequal|rawget|rawlen|rawset|require|rotation|select|setmetatable|tonumber|toquaternion|torotation|tostring|touuid|tovector|type|typeof|unpack|uuid|vector|xpcall)\\b"
          },
          {
            "name": "constant.language.luau",
            "match": "(?<![^.]\\.|:)\\b(_G|_VERSION)\\b"
          },
          {
            "name": "support.function.luau",
            "match": "(?<![^.]\\.|:)\\b(bit32\\.(?:arshift|band|bnot|bor|btest|bxor|byteswap|countlz|countrz|extract|lrotate|lshift|replace|rrotate|rshift|s32|smul)|buffer\\.(?:copy|create|fill|fromstring|len|readbits|readf32|readf64|readi16|readi32|readi8|readstring|readu16|readu32|readu8|tostring|writebits|writef32|writef64|writei16|writei32|writei8|writestring|writeu16|writeu32|writeu8)|coroutine\\.(?:close|create|isyieldable|resume|running|status|wrap|yield)|debug\\.(?:info|traceback)|llbase64\\.(?:decode|encode)|lljson\\.(?:decode|encode|sldecode|slencode)|math\\.(?:abs|acos|asin|atan|atan2|ceil|clamp|cos|cosh|deg|exp|floor|fmod|frexp|isfinite|isinf|isnan|ldexp|lerp|log|log10|map|max|min|modf|noise|pow|rad|random|randomseed|round|sign|sin|sinh|sqrt|tan|tanh)|os\\.(?:clock|date|difftime|time)|quaternion\\.(?:conjugate|create|dot|magnitude|normalize|slerp|tofwd|toleft|toup)|rotation\\.(?:conjugate|create|dot|magnitude|normalize|slerp|tofwd|toleft|toup)|string\\.(?:byte|char|find|format|gmatch|gsub|len|lower|match|pack|packsize|rep|reverse|split|sub|unpack|upper)|table\\.(?:append|clear|clone|concat|create|extend|find|foreach|foreachi|freeze|getn|insert|isfrozen|maxn|move|pack|remove|shrink|sort|unpack)|utf8\\.(?:char|codepoint|codes|len|offset)|uuid\\.(?:create)|vector\\.(?:abs|angle|ceil|clamp|create|cross|dot|floor|lerp|magnitude|max|min|normalize|sign))\\b"
          },
          {
            "name": "support.function.luau",
            "match": "(?<![^.]\\.|:)\\b(ll\\.(?:A(?:d(?:dToLand(?:BanList|PassList)|justSoundVolume)|gentInExperience|llowInventoryDrop|ngleBetween|pply(?:Impulse|RotationalImpulse)|ttachToAvatar(?:Temp)?|vatarOn(?:LinkSitTarget|SitTarget)|x(?:es2Rot|isAngle2Rot))|Break(?:AllLinks|Link)|C(?:SV2List|astRay|har|lear(?:CameraParams|LinkMedia|PrimMedia)|o(?:llision(?:Filter|Sound)|mputeHash)|reate(?:Character|KeyValue|Link))|D(?:a(?:mage|taSizeKeyValue)|e(?:lete(?:Character|KeyValue|SubString)|rezObject|tachFromAvatar)|i(?:alog|e)|umpList2String)|E(?:dgeOfWorld|jectFromLand|mail|scapeURL|uler2Rot|vade|xecCharacterCmd)|F(?:indNotecardText(?:Count|Sync)|leeFrom|orceMouselook|rand)|G(?:e(?:nerateKey|t(?:A(?:ccel|gent(?:Info|L(?:anguage|ist)|Size)|lpha|nimation(?:(?:List|Override))?|ttached(?:List(?:Filtered)?)?)|BoundingBox|C(?:amera(?:Aspect|FOV|Pos|Rot)|enterOfMass|losestNavPoint|olor|reator)|D(?:a(?:te|y(?:Length|Offset))|isplayName)|E(?:n(?:ergy|v(?:ironment)?)|xperience(?:Details|ErrorMessage))|F(?:orce|ree(?:Memory|URLs))|G(?:MTclock|eometricCenter)|H(?:TTPHeader|ealth)|Inventory(?:AcquireTime|Creator|Desc|Key|N(?:ame|umber)|PermMask|Type)|Key|L(?:andOwnerAt|ink(?:Key|Media|N(?:ame|umber(?:OfSides)?)|PrimitiveParams|SitFlags)|ocal(?:Pos|Rot))|M(?:a(?:ss(?:MKS)?|xScaleFactor)|emoryLimit|inScaleFactor|oon(?:Direction|Rotation))|N(?:extEmail|otecardLine(?:Sync)?|umberOf(?:NotecardLines|Prims|Sides))|O(?:bject(?:AnimationNames|De(?:sc|tails)|LinkKey|Mass|Name|P(?:ermMask|rimCount))|mega|wner(?:Key)?)|P(?:arcel(?:Details|Flags|M(?:axPrims|usicURL)|Prim(?:Count|Owners))|ermissions(?:Key)?|hysicsMaterial|os|rim(?:MediaParams|itiveParams))|R(?:e(?:gion(?:AgentCount|Corner|Day(?:Length|Offset)|F(?:PS|lags)|Moon(?:Direction|Rotation)|Name|Sun(?:Direction|Rotation)|Time(?:Dilation|OfDay))|nderMaterial)|o(?:ot(?:Position|Rotation)|t))|S(?:PMaxMemory|c(?:ale|ript(?:Name|State))|im(?:Stats|ulatorHostname)|ta(?:rt(?:Parameter|String)|t(?:icPath|us))|u(?:bString|n(?:Direction|Rotation)))|T(?:exture(?:(?:Offset|Rot|Scale))?|ime(?:(?:OfDay|stamp))?|orque)|Use(?:dMemory|rname)|V(?:el|isualParams)|Wallclock))|ive(?:AgentInventory|Inventory(?:List)?|Money)|odLikeRezObject|round(?:(?:Contour|Normal|Repel|Slope))?)|H(?:MAC|TTPRe(?:quest|sponse)|ash)|I(?:n(?:s(?:ertString|tantMessage)|tegerToBase64)|s(?:Friend|LinkGLTFMaterial))|Key(?:2Name|CountKeyValue|sKeyValue)|L(?:i(?:n(?:ear2sRGB|k(?:AdjustSoundVolume|P(?:articleSystem|laySound)|S(?:etSound(?:Queueing|Radius)|itTarget|topSound)|setData(?:Available|Count(?:Found|Keys)|Delete(?:(?:Found|Protected))?|FindKeys|ListKeys|Re(?:ad(?:Protected)?|set)|Write(?:Protected)?)))|st(?:2CSV|Randomize|S(?:ort|tatistics)|en(?:(?:Control|Remove))?))|o(?:adURL|o(?:kAt|pSound(?:(?:Master|Slave))?)))|M(?:D5String|a(?:nageEstateAccess|p(?:Beacon|Destination))|essageLinked|inEventDelay|o(?:d(?:Pow|ifyLand)|veToTarget))|Na(?:me2Key|vigateTo)|O(?:ffsetTexture|penFloater|rd|verMyLand)|P(?:a(?:r(?:celMedia(?:CommandList|Query)|seString(?:2List|KeepNulls)|ticleSystem)|ss(?:Collisions|Touches)|trolPoints)|laySound(?:Slave)?|reloadSound|u(?:rsue|shObject))|R(?:e(?:adKeyValue|gionSay(?:To)?|lease(?:Controls|URL)|mo(?:teLoadScriptPin|ve(?:FromLand(?:BanList|PassList)|Inventory|VehicleFlags))|place(?:AgentEnvironment|Environment|SubString)|quest(?:AgentData|DisplayName|ExperiencePermissions|InventoryData|Permissions|S(?:ecureURL|imulatorData)|U(?:RL|ser(?:Key|name)))|set(?:AnimationOverride|Land(?:BanList|PassList)|OtherScript|Script)|turnObjectsBy(?:ID|Owner)|z(?:AtRoot|Object(?:WithParams)?))|ot(?:2(?:A(?:ngle|xis)|Euler)|Between|LookAt|Target(?:Remove)?|ateTexture))|S(?:HA(?:1String|256String)|a(?:meGroup|y)|c(?:ale(?:ByFactor|Texture)|ript(?:Danger|Profiler))|e(?:nsor(?:Re(?:move|peat))?|t(?:A(?:gent(?:Environment|Rot)|lpha|n(?:gularVelocity|imationOverride))|Buoyancy|C(?:amera(?:AtOffset|EyeOffset|Params)|lickAction|o(?:lor|ntentType))|Damage|Environment|Force(?:AndTorque)?|GroundTexture|HoverHeight|InventoryPermMask|KeyframedMotion|L(?:ink(?:Alpha|C(?:amera|olor)|GLTFOverrides|Media|PrimitiveParamsFast|RenderMaterial|SitFlags|Texture(?:Anim)?)|ocalRot)|Object(?:Desc|Name|PermMask)|P(?:a(?:rcel(?:ForSale|MusicURL)|yPrice)|hysicsMaterial|os|rimMediaParams)|R(?:e(?:gionPos|moteScriptAccessPin|nderMaterial)|ot)|S(?:c(?:ale|riptState)|itText|ound(?:Queueing|Radius)|tatus)|T(?:ext(?:ure(?:Anim)?)?|o(?:rque|uchText))|Ve(?:hicle(?:Fl(?:ags|oatParam)|RotationParam|Type|VectorParam)|locity)))|hout|i(?:gnRSA|t(?:OnLink|Target))|leep|t(?:art(?:Animation|ObjectAnimation)|op(?:Animation|Hover|LookAt|MoveToTarget|ObjectAnimation|Sound)|ringTrim)|ubStringIndex)|T(?:a(?:keControls|rget(?:(?:Omega|Remove|edEmail))?)|e(?:leportAgent(?:(?:GlobalCoords|Home))?|xtBox)|o(?:Lower|Upper)|r(?:ansfer(?:LindenDollars|Ownership)|iggerSound(?:Limited)?))|U(?:n(?:Sit|escapeURL)|pdate(?:Character|KeyValue))|V(?:erifyRSA|olumeDetect)|W(?:a(?:nderWithin|ter)|hisper|ind|orldPosToHUD)|XorBase64|sRGB2Linear))\\b"
          },
          {
            "name": "invalid.deprecated.support.function.luau",
            "match": "(?<![^.]\\.|:)\\b(ll\\.(?:A(?:bs|cos|djustDamage|sin|tan2)|Base64To(?:Integer|String)|C(?:eil|lo(?:seRemoteDataChannel|ud)|o(?:llisionSprite|s))|De(?:leteSubList|tected(?:Damage|Gr(?:ab|oup)|Key|LinkNumber|Name|Owner|Pos|R(?:ezzer|ot)|T(?:ouch(?:Binormal|Face|Normal|Pos|ST|UV)|ype)|Vel))|F(?:abs|loor)|Get(?:List(?:EntryType|Length)|UnixTime)|Json(?:2List|GetValue|SetValue|ValueType)|L(?:ist(?:2(?:Float|Integer|Json|Key|List(?:S(?:lice|trided))?|Rot|String|Vector)|Find(?:List(?:Next)?|Strided)|InsertList|ReplaceList|SortStrided)|og(?:10)?)|Make(?:Explosion|F(?:ire|ountain)|Smoke)|O(?:penRemoteDataChannel|wnerSay)|Pow|R(?:e(?:freshPrimURL|leaseCamera|moteData(?:Reply|SetRegion))|o(?:t2(?:Fwd|Left|Up)|und))|S(?:e(?:ndRemoteData|t(?:LinkPrimitiveParams|Prim(?:URL|itiveParams)))|in|ound(?:Preload)?|qrt|tring(?:Length|ToBase64))|Ta(?:keCamera|n)|Vec(?:Dist|Mag|Norm)|XorBase64Strings(?:Correct)?))\\b"
          },
          {
            "name": "support.function.luau",
            "match": "(?<![^.]\\.|:)\\b(LL(?:Events:(?:eventNames|handlers|o(?:ff|n(?:ce)?))|Timers:(?:every|o(?:ff|nce))))\\b"
          },
          {
            "name": "support.constant.luau",
            "match": "(?<![^.]\\.|:)\\b(bit32|buffer|coroutine|debug|ll|llbase64|llcompat|lljson(\\.array_mt|empty_array|empty_object|null|object_mt|remove)?|llprim(\\.ParamsSetter)?|math(\\.huge|pi)?|os|quaternion(\\.identity)?|rotation(\\.identity)?|string|table|utf8(\\.charpattern)?|uuid|vector(\\.one|zero)?)\\b"
          },
          {
            "name": "support.constant.luau",
            "match": "(?<![^.]\\.|:)\\b(LLEvents\\.(?:at(?:_(?:rot_target|target)|tach)|c(?:hanged|o(?:llision(?:_(?:end|start))?|ntrol))|dataserver|e(?:mail|xperience_permissions(?:_denied)?)|final_damage|game_control|http_re(?:quest|sponse)|l(?:and_collision(?:_(?:end|start))?|i(?:nk(?:_message|set_data)|sten))|mo(?:ney|ving_(?:end|start))|no(?:_sensor|t_at_(?:rot_target|target))|o(?:bject_rez|n_(?:d(?:amage|eath)|rez))|path_update|r(?:emote_data|un_time_permissions)|sensor|t(?:imer|ouch(?:_(?:end|start))?|ransaction_result)))\\b"
          },
          {
            "name": "support.constant.luau",
            "match": "(?<![^.]\\.|:)\\b(?:A(?:CTIVE|GENT(?:_(?:A(?:LWAYS_RUN|TTACHMENTS|UTO(?:MATED|PILOT)|WAY)|B(?:USY|Y_(?:LEGACY_NAME|USERNAME))|CROUCHING|FL(?:OATING_VIA_SCRIPTED_ATTACHMENT|YING)|IN_AIR|LIST_(?:PARCEL(?:_OWNER)?|REGION)|MOUSELOOK|ON_OBJECT|S(?:CRIPTED|ITTING)|TYPING|WALKING))?|LL_SIDES|NIM_ON|TTACH_(?:A(?:NY_HUD|VATAR_CENTER)|B(?:ACK|ELLY)|CH(?:EST|IN)|FACE_(?:JAW|LE(?:AR|YE)|RE(?:AR|YE)|TONGUE)|GROIN|H(?:EAD|IND_(?:LFOOT|RFOOT)|UD_(?:BOTTOM(?:_(?:LEFT|RIGHT))?|CENTER_[12]|TOP_(?:CENTER|LEFT|RIGHT)))|L(?:E(?:AR|FT_PEC|YE)|FOOT|H(?:AND(?:_RING1)?|IP)|L(?:ARM|LEG)|PEC|SHOULDER|U(?:ARM|LEG)|WING)|MOUTH|N(?:ECK|OSE)|PELVIS|R(?:E(?:AR|YE)|FOOT|H(?:AND(?:_RING1)?|IP)|IGHT_PEC|L(?:ARM|LEG)|PEC|SHOULDER|U(?:ARM|LEG)|WING)|TAIL_(?:BASE|TIP))|VOID_(?:CHARACTERS|DYNAMIC_OBSTACLES|NONE))|BEACON_MAP|C(?:AMERA_(?:ACTIVE|BEHINDNESS_(?:ANGLE|LAG)|DISTANCE|FOCUS(?:_(?:L(?:AG|OCKED)|OFFSET|THRESHOLD))?|P(?:ITCH|OSITION(?:_(?:L(?:AG|OCKED)|THRESHOLD))?))|HA(?:NGED_(?:ALLOWED_DROP|COLOR|INVENTORY|LINK|MEDIA|OWNER|RE(?:GION(?:_START)?|NDER_MATERIAL)|S(?:CALE|HAPE)|TE(?:LEPORT|XTURE))|RACTER_(?:A(?:CCOUNT_FOR_SKIPPED_FRAMES|VOIDANCE_MODE)|CMD_(?:JUMP|S(?:MOOTH_STOP|TOP))|DESIRED_(?:SPEED|TURN_SPEED)|LENGTH|MAX_(?:ACCEL|DECEL|SPEED|TURN_RADIUS)|ORIENTATION|RADIUS|STAY_WITHIN_PARCEL|TYPE(?:_(?:NONE|[ABCD]))?))|LICK_ACTION_(?:BUY|DISABLED|IGNORE|NONE|OPEN(?:_MEDIA)?|P(?:AY|LAY)|SIT|TOUCH|ZOOM)|O(?:MBAT_(?:CHANNEL|LOG_ID)|NT(?:ENT_TYPE_(?:ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|X(?:HTML|ML))|ROL_(?:BACK|DOWN|FWD|L(?:BUTTON|EFT)|ML_LBUTTON|R(?:IGHT|OT_(?:LEFT|RIGHT))|UP))))|D(?:A(?:MAGE(?:ABLE|_TYPE_(?:ACID|BLUDGEONING|COLD|E(?:LECTRIC|MOTIONAL)|F(?:IRE|ORCE)|GENERIC|IMPACT|NECROTIC|P(?:IERCING|OISON|SYCHIC)|RADIANT|S(?:LASHING|ONIC)))|TA_(?:BORN|NAME|ONLINE|PAYINFO|R(?:ATING|ESERVED_0)|SIM_(?:POS|RATING|STATUS)))|E(?:BUG_CHANNEL|G_TO_RAD|NSITY|REZ_(?:DIE|MAKE_TEMP|TO_INVENTORY)))|E(?:NV(?:IRONMENT_DAYINFO|_(?:INVALID_(?:AGENT|RULE)|NO(?:T_EXPERIENCE|_(?:E(?:NVIRONMENT|XPERIENCE_(?:LAND|PERMISSION))|PERMISSIONS))|OK|THROTTLE|VALIDATION_FAIL))|OF|RR_(?:GENERIC|MALFORMED_PARAMS|PARCEL_PERMISSIONS|RUNTIME_PERMISSIONS|THROTTLED)|STATE_ACCESS_(?:ALLOWED_(?:AGENT_(?:ADD|REMOVE)|GROUP_(?:ADD|REMOVE))|BANNED_AGENT_(?:ADD|REMOVE)))|F(?:ILTER_(?:FLAG(?:_HUDS|S)|INCLUDE)|ORCE_DIRECT_PATH|RICTION)|G(?:AME_CONTROL_(?:AXIS_(?:LEFT[XY]|RIGHT[XY]|TRIGGER(?:LEFT|RIGHT))|BUTTON_(?:B(?:ACK)?|DPAD_(?:DOWN|LEFT|RIGHT|UP)|GUIDE|LEFTS(?:HOULDER|TICK)|MISC1|PADDLE[1234]|RIGHTS(?:HOULDER|TICK)|START|TOUCHPAD|[AXY]))|CNP_(?:GET_WALKABILITY|RADIUS|STATIC)|RAVITY_MULTIPLIER)|H(?:ORIZONTAL|TTP_(?:ACCEPT|BODY_(?:MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|EXTENDED_ERROR|M(?:ETHOD|IMETYPE)|PRAGMA_NO_CACHE|USER_AGENT|VER(?:BOSE_THROTTLE|IFY_CERT)))|I(?:MG_USE_BAKED_(?:AUX[123]|EYES|H(?:AIR|EAD)|L(?:EFT(?:ARM|LEG)|OWER)|SKIRT|UPPER)|NVENTORY_(?:A(?:LL|NIMATION)|BODYPART|CLOTHING|GESTURE|LANDMARK|MATERIAL|NO(?:NE|TECARD)|OBJECT|S(?:CRIPT|ETTING|OUND)|TEXTURE))|JSON_(?:A(?:PPEND|RRAY)|DELETE|FALSE|INVALID|NU(?:LL|MBER)|OBJECT|STRING|TRUE)|KFM_(?:C(?:MD_(?:P(?:AUSE|LAY)|STOP)|OMMAND)|DATA|FORWARD|LOOP|MODE|PING_PONG|R(?:EVERSE|OTATION)|TRANSLATION)|L(?:AND_(?:BRUSH_(?:LARGE|MEDIUM|SMALL)|L(?:ARGE_BRUSH|EVEL|OWER)|MEDIUM_BRUSH|NOISE|R(?:AISE|EVERT)|SM(?:ALL_BRUSH|OOTH))|EGACY_MASS_FACTOR|I(?:NK(?:SETDATA_(?:DELETE|E(?:MEMORY|NOKEY|PROTECTED)|MULTIDELETE|NO(?:TFOUND|UPDATE)|OK|RESET|UPDATE)|_(?:ALL_(?:CHILDREN|OTHERS)|ROOT|SET|THIS))|ST_STAT_(?:GEOMETRIC_MEAN|M(?:AX|E(?:AN|DIAN)|IN)|NUM_COUNT|RANGE|S(?:TD_DEV|UM(?:_SQUARES)?)))|OOP)|MASK_(?:BASE|COMBINED|EVERYONE|GROUP|NEXT|OWNER)|N(?:A(?:VIGATE_TO_GOAL_REACHED_DIST|K)|ULL_KEY)|O(?:BJECT_(?:A(?:CCOUNT_LEVEL|NIMATED_(?:COUNT|SLOTS_AVAILABLE)|TTACHED_(?:POINT|SLOTS_AVAILABLE))|BODY_SHAPE_TYPE|C(?:HARACTER_TIME|LICK_ACTION|REAT(?:ION_TIME|OR))|D(?:AMAGE(?:_TYPE)?|ESC)|GROUP(?:_TAG)?|H(?:EALTH|OVER_HEIGHT)|L(?:AST_OWNER_ID|INK_NUMBER)|MA(?:SS|TERIAL)|NAME|O(?:MEGA|WNER)|P(?:ATHFINDING_TYPE|ERMS(?:_COMBINED)?|H(?:ANTOM|YSICS(?:_COST)?)|OS|RIM_(?:COUNT|EQUIVALENCE))|R(?:E(?:NDER_WEIGHT|TURN_(?:PARCEL(?:_OWNER)?|REGION)|Z(?:ZER_KEY|_TIME))|O(?:OT|T)|UNNING_SCRIPT_COUNT)|S(?:C(?:ALE|RIPT_(?:MEMORY|TIME))|E(?:LECT_COUNT|RVER_COST)|IT_COUNT|TREAMING_COST)|T(?:E(?:MP_(?:ATTACHED|ON_REZ)|XT(?:_(?:ALPHA|COLOR))?)|OTAL_(?:INVENTORY_COUNT|SCRIPT_COUNT))|UNKNOWN_DETAIL|VELOCITY)|PT_(?:AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|VERRIDE_GLTF_(?:BASE_(?:ALPHA(?:_M(?:ASK|ODE))?|COLOR_FACTOR|DOUBLE_SIDED)|EMISSIVE_FACTOR|METALLIC_FACTOR|ROUGHNESS_FACTOR))|P(?:A(?:RCEL_(?:COUNT_(?:GROUP|O(?:THER|WNER)|SELECTED|T(?:EMP|OTAL))|DETAILS_(?:AREA|DESC|FLAGS|GROUP|ID|LANDING_(?:LOOKAT|POINT)|NAME|OWNER|PRIM_(?:CAPACITY|USED)|S(?:CRIPT_DANGER|EE_AVATARS)|TP_ROUTING)|FLAG_(?:ALLOW_(?:ALL_OBJECT_ENTRY|CREATE_(?:GROUP_OBJECTS|OBJECTS)|DAMAGE|FLY|GROUP_(?:OBJECT_ENTRY|SCRIPTS)|LANDMARK|SCRIPTS|TERRAFORM)|L(?:INDEN_HOMES|OCAL_SOUND_ONLY)|RESTRICT_PUSHOBJECT|USE_(?:ACCESS_(?:GROUP|LIST)|BAN_LIST|LAND_PASS_LIST))|MEDIA_COMMAND_(?:A(?:GENT|UTO_ALIGN)|DESC|LOOP(?:_SET)?|P(?:AUSE|LAY)|S(?:IZE|TOP)|T(?:EXTURE|IME|YPE)|U(?:NLOAD|RL))|SALE_(?:AGENT|ERROR_(?:BAD_PARAMS|IN(?:VALID_PRICE|_ESCROW)|NO_P(?:ARCEL|ERMISSIONS))|O(?:BJECTS|K)|PRICE))|SS(?:IVE|_(?:ALWAYS|IF_NOT_HANDLED|NEVER))|TROL_PAUSE_AT_WAYPOINTS|Y(?:MENT_INFO_(?:ON_FILE|USED)|_(?:DEFAULT|HIDE)))|ERM(?:ISSION_(?:ATTACH|C(?:HANGE_(?:JOINTS|LINKS|PERMISSIONS)|ONTROL_CAMERA)|DEBIT|OVERRIDE_ANIMATIONS|PRIVILEGED_LAND_ACCESS|RE(?:LEASE_OWNERSHIP|MAP_CONTROLS|TURN_OBJECTS)|SILENT_ESTATE_MANAGEMENT|T(?:AKE_CONTROLS|ELEPORT|R(?:ACK_CAMERA|IGGER_ANIMATION)))|_(?:ALL|COPY|MO(?:DIFY|VE)|TRANSFER))|I(?:(?:NG_PONG|_BY_TWO))?|R(?:IM_(?:AL(?:LOW_UNSIT|PHA_MODE(?:_(?:BLEND|EMISSIVE|MASK|NONE))?)|BUMP_(?:B(?:ARK|LOBS|RI(?:CKS|GHT))|C(?:HECKER|ONCRETE)|D(?:ARK|ISKS)|GRAVEL|LARGETILE|NONE|S(?:HINY|IDING|T(?:ONE|UCCO)|UCTION)|TILE|W(?:EAVE|OOD))|C(?:AST_SHADOWS|LICK_ACTION|OL(?:LISION_SOUND|OR))|D(?:AMAGE|ESC)|F(?:LEXIBLE|ULLBRIGHT)|GL(?:OW|TF_(?:ALPHA_MODE_(?:BLEND|MASK|OPAQUE)|BASE_COLOR|EMISSIVE|METALLIC_ROUGHNESS|NORMAL))|H(?:EALTH|OLE_(?:CIRCLE|DEFAULT|SQUARE|TRIANGLE))|LINK_TARGET|M(?:ATERIAL(?:_(?:DENSITY|F(?:LESH|RICTION)|G(?:LASS|RAVITY_MULTIPLIER)|LIGHT|METAL|PLASTIC|R(?:ESTITUTION|UBBER)|STONE|WOOD))?|EDIA_(?:A(?:LT_IMAGE_ENABLE|UTO_(?:LOOP|PLAY|SCALE|ZOOM))|C(?:ONTROLS(?:_(?:MINI|STANDARD))?|URRENT_URL)|FIRST_CLICK_INTERACT|H(?:EIGHT_PIXELS|OME_URL)|MAX_(?:HEIGHT_PIXELS|URL_LENGTH|W(?:HITELIST_(?:COUNT|SIZE)|IDTH_PIXELS))|P(?:ARAM_MAX|ERM(?:S_(?:CONTROL|INTERACT)|_(?:ANYONE|GROUP|NONE|OWNER)))|W(?:HITELIST(?:_ENABLE)?|IDTH_PIXELS)))|N(?:AME|ORMAL)|OMEGA|P(?:H(?:ANTOM|YSICS(?:_SHAPE_(?:CONVEX|NONE|PRIM|TYPE))?)|O(?:INT_LIGHT|S(?:ITION|_LOCAL))|ROJECTOR)|R(?:E(?:FLECTION_PROBE(?:_(?:BOX|DYNAMIC|MIRROR))?|NDER_MATERIAL)|OT(?:ATION|_LOCAL))|S(?:C(?:RIPTED_SIT_ONLY|ULPT_(?:FLAG_(?:ANIMESH|INVERT|MIRROR)|TYPE_(?:CYLINDER|M(?:ASK|ESH)|PLANE|SPHERE|TORUS)))|HINY_(?:HIGH|LOW|MEDIUM|NONE)|I(?:T_(?:FLAGS|TARGET)|ZE)|LICE|PECULAR)|T(?:E(?:MP_ON_REZ|X(?:GEN(?:_(?:DEFAULT|PLANAR))?|T(?:URE)?))|YPE(?:_(?:BOX|CYLINDER|PRISM|RING|S(?:CULPT|PHERE)|T(?:ORUS|UBE)))?))|OFILE_(?:NONE|SCRIPT_MEMORY))|SYS_(?:PART_(?:B(?:F_(?:DEST_COLOR|ONE(?:_MINUS_(?:DEST_COLOR|SOURCE_(?:ALPHA|COLOR)))?|SOURCE_(?:ALPHA|COLOR)|ZERO)|LEND_FUNC_(?:DEST|SOURCE)|OUNCE_MASK)|E(?:MISSIVE_MASK|ND_(?:ALPHA|COLOR|GLOW|SCALE))|F(?:LAGS|OLLOW_(?:SRC_MASK|VELOCITY_MASK))|INTERP_(?:COLOR_MASK|SCALE_MASK)|MAX_AGE|RIBBON_MASK|START_(?:ALPHA|COLOR|GLOW|SCALE)|TARGET_(?:LINEAR_MASK|POS_MASK)|WIND_MASK)|SRC_(?:A(?:CCEL|NGLE_(?:BEGIN|END))|BURST_(?:PART_COUNT|RA(?:DIUS|TE)|SPEED_M(?:AX|IN))|INNERANGLE|MAX_AGE|O(?:BJ_REL_MASK|MEGA|UTERANGLE)|PATTERN(?:_(?:ANGLE(?:_CONE(?:_EMPTY)?)?|DROP|EXPLODE))?|T(?:ARGET_KEY|EXTURE)))|U(?:BLIC_CHANNEL|RSUIT_(?:FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT|OFFSET)|_(?:EVADE_(?:HIDDEN|SPOTTED)|FAILURE_(?:DYNAMIC_PATHFINDING_DISABLED|INVALID_(?:GOAL|START)|NO_(?:NAVMESH|VALID_DESTINATION)|OTHER|PARCEL_UNREACHABLE|TARGET_GONE|UNREACHABLE)|GOAL_REACHED|SLOWDOWN_DISTANCE_REACHED)))|R(?:AD_TO_DEG|C(?:ERR_(?:CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|_(?:D(?:ATA_FLAGS|ETECT_PHANTOM)|GET_(?:LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(?:AGENTS|LAND|NONPHYSICAL|PHYSICAL|TYPES)))|E(?:GION_FLAG_(?:ALLOW_D(?:AMAGE|IRECT_TELEPORT)|BLOCK_(?:FLY(?:OVER)?|TERRAFORM)|DISABLE_(?:COLLISIONS|PHYSICS)|FIXED_SUN|RESTRICT_PUSHOBJECT|SANDBOX)|MOTE_DATA_(?:CHANNEL|RE(?:PLY|QUEST))|QUIRE_LINE_OF_SIGHT|STITUTION|VERSE|Z_(?:ACCEL|DAMAGE(?:_TYPE)?|FLAG(?:_(?:BLOCK_GRAB_OBJECT|DIE_ON_(?:COLLIDE|NOENTRY)|NO_COLLIDE_(?:FAMILY|OWNER)|PH(?:ANTOM|YSICAL)|TEMP)|S)|LOCK_AXES|OMEGA|P(?:ARAM(?:_STRING)?|OS)|ROT|SOUND(?:_COLLIDE)?|TORQUE|VEL))|OTATE)|S(?:C(?:ALE|RIPTED)|I(?:M_STAT_(?:A(?:CTIVE_SCRIPT_COUNT|GENT_(?:COUNT|MS|UPDATES)|I_MS|SSET_(?:DOWNLOADS|UPLOADS))|CHILD_AGENT_COUNT|FRAME_MS|I(?:MAGE_MS|O_PUMP_MS)|NET_MS|OTHER_MS|P(?:ACKETS_(?:IN|OUT)|CT_CHARS_STEPPED|HYSICS_(?:FPS|MS|OTHER_MS|S(?:HAPE_MS|TEP_MS)))|S(?:CRIPT_(?:EPS|MS|RUN_PCT)|LEEP_MS|PARE_MS)|UNACKED_BYTES)|T_(?:FLAG_(?:ALLOW_UNSIT|NO_(?:COLLIDE|DAMAGE)|S(?:CRIPTED_ONLY|IT_TARGET))|INVALID_(?:AGENT|LINK|OBJECT)|NO(?:T_EXPERIENCE|_(?:ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET))|OK))|KY_(?:A(?:BSORPTION_CONFIG|MBIENT)|BLUE|CLOUD(?:_TEXTURE|S)|D(?:ENSITY_PROFILE_COUNTS|OME)|G(?:AMMA|LOW)|HAZE|LIGHT|M(?:IE_CONFIG|OON(?:_TEXTURE)?)|PLANET|R(?:AYLEIGH_CONFIG|EF(?:LECTION_PROBE_AMBIANCE|RACTION))|S(?:TAR_BRIGHTNESS|UN(?:_TEXTURE)?)|T(?:EXTURE_DEFAULTS|RACKS))|MOOTH|OUND_(?:LOOP|PLAY|SYNC|TRIGGER)|QRT2|T(?:ATUS_(?:B(?:LOCK_GRAB(?:_OBJECT)?|OUNDS_ERROR)|CAST_SHADOWS|DIE_AT_(?:EDGE|NO_ENTRY)|INTERNAL_ERROR|MALFORMED_PARAMS|NOT_(?:FOUND|SUPPORTED)|OK|PH(?:ANTOM|YSICS)|R(?:ETURN_AT_EDGE|OTATE_[XYZ])|SANDBOX|TYPE_MISMATCH|WHITELIST_FAILED)|RING_TRIM(?:_(?:HEAD|TAIL))?))|T(?:ARGETED_EMAIL_(?:OBJECT_OWNER|ROOT_CREATOR)|E(?:RRAIN_(?:DETAIL_[1234]|HEIGHT_RANGE_(?:N[EW]|S[EW])|PBR_(?:OFFSET_[1234]|ROTATION_[1234]|SCALE_[1234]))|XTURE_(?:BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT))|OUCH_INVALID_(?:FACE|TEXCOORD|VECTOR)|P_ROUTING_(?:BLOCKED|FREE|LANDINGP)|RA(?:NSFER_(?:BAD_(?:OPTS|ROOT)|DEST|FLAG(?:_(?:COPY|RESERVED|TAKE)|S)|NO_(?:ATTACHMENT|ITEMS|PERMS|TARGET)|OK|THROTTLE)|VERSAL_TYPE(?:_(?:FAST|NONE|SLOW))?)|WO_PI|YPE_(?:FLOAT|IN(?:TEGER|VALID)|KEY|ROTATION|STRING|VECTOR))|URL_REQUEST_(?:DENIED|GRANTED)|VE(?:HICLE_(?:ANGULAR_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|FRICTION_TIMESCALE|MOTOR_(?:D(?:ECAY_TIMESCALE|IRECTION)|TIMESCALE))|B(?:ANKING_(?:EFFICIENCY|MIX|TIMESCALE)|UOYANCY)|FLAG_(?:BLOCK_INTERFERENCE|CAMERA_DECOUPLED|HOVER_(?:GLOBAL_HEIGHT|TERRAIN_ONLY|UP_ONLY|WATER_ONLY)|LIMIT_(?:MOTOR_UP|ROLL_ONLY)|MOUSELOOK_(?:BANK|STEER)|NO_(?:DEFLECTION_UP|FLY_UP))|HOVER_(?:EFFICIENCY|HEIGHT|TIMESCALE)|LINEAR_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|FRICTION_TIMESCALE|MOTOR_(?:D(?:ECAY_TIMESCALE|IRECTION)|OFFSET|TIMESCALE))|REFERENCE_FRAME|TYPE_(?:AIRPLANE|B(?:ALLOON|OAT)|CAR|NONE|SLED)|VERTICAL_ATTRACTION_(?:EFFICIENCY|TIMESCALE))|RTICAL)|WA(?:NDER_PAUSE_AT_WAYPOINTS|TER_(?:BLUR_MULTIPLIER|F(?:OG|RESNEL)|NORMAL_(?:SCALE|TEXTURE)|REFRACTION|TEXTURE_DEFAULTS|WAVE_DIRECTION))|XP_ERROR_(?:EXPERIENCE(?:S_DISABLED|_(?:DISABLED|SUSPENDED))|INVALID_(?:EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NO(?:NE|T_(?:FOUND|PERMITTED(?:_LAND)?)|_EXPERIENCE)|QUOTA_EXCEEDED|RE(?:QUEST_PERM_TIMEOUT|TRY_UPDATE)|STOR(?:AGE_EXCEPTION|E_DISABLED)|THROTTLED|UNKNOWN_ERROR)|ZERO_(?:ROTATION|VECTOR))\\b"
          }
        ]
      },
      "keyword": {
        "patterns": [
          {
            "match": "\\b(break|do|else|for|if|elseif|return|then|repeat|while|until|end|in|continue)\\b",
            "name": "keyword.control.luau"
          },
          {
            "match": "\\b(local)\\b",
            "name": "storage.modifier.local.luau"
          },
          {
            "match": "\\b(const)\\b",
            "name": "storage.modifier.const.luau"
          },
          {
            "match": "\\b(function)\\b(?![,:])",
            "name": "keyword.control.luau"
          },
          {
            "match": "(?<![^.]\\.|:)\\b(self)\\b",
            "name": "variable.language.self.luau"
          },
          {
            "match": "\\b(and|or|not)\\b",
            "name": "keyword.operator.logical.luau keyword.operator.wordlike.luau"
          },
          {
            "name": "variable.language.metamethod.luau",
            "match": "(?<=[^.]\\.|:)\\b(__(?:add|call|concat|div|eq|index|le|len|lt|metatable|mod|mode|mul|newindex|pow|sub|tostring|unm|iter|idiv|tojson|jsonhint))\\b"
          },
          {
            "name": "keyword.other.unit.luau",
            "match": "(?<![.])\\.{3}(?!\\.)"
          }
        ]
      },
      "identifier": {
        "patterns": [
          {
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b(?=\\s*(?:<<|[({\"']|\\[\\[))",
            "name": "entity.name.function.luau"
          },
          {
            "match": "(?<=[^.]\\.|:)\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b",
            "name": "variable.other.property.luau"
          },
          {
            "match": "\\b([A-Z_][A-Z0-9_]*)\\b",
            "name": "variable.other.constant.luau"
          },
          {
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b",
            "name": "variable.other.readwrite.luau"
          }
        ]
      },
      "operator": {
        "patterns": [
          {
            "match": "==|~=|<=?|>=?",
            "name": "keyword.operator.comparison.luau"
          },
          {
            "match": "\\+=|-=|/=|//=|\\*=|%=|\\^=|\\.\\.=|=",
            "name": "keyword.operator.assignment.luau"
          },
          {
            "match": "\\+|-|%|\\*|\\/\\/|\\/|\\^",
            "name": "keyword.operator.arithmetic.luau"
          },
          {
            "match": "#|(?<!\\.)\\.{2}(?!\\.)",
            "name": "keyword.operator.other.luau"
          }
        ]
      },
      "parentheses": {
        "begin": "(\\()",
        "beginCaptures": {
          "1": {
            "name": "punctuation.arguments.begin.luau"
          }
        },
        "end": "(\\))",
        "endCaptures": {
          "1": {
            "name": "punctuation.arguments.end.luau"
          }
        },
        "patterns": [
          {
            "match": ",",
            "name": "punctuation.separator.arguments.luau"
          },
          {
            "include": "source.luau"
          }
        ]
      },
      "table": {
        "begin": "(\\{)",
        "beginCaptures": {
          "1": {
            "name": "punctuation.table.begin.luau"
          }
        },
        "end": "(\\})",
        "endCaptures": {
          "1": {
            "name": "punctuation.table.end.luau"
          }
        },
        "patterns": [
          {
            "match": "[,;]",
            "name": "punctuation.separator.fields.luau"
          },
          {
            "include": "source.luau"
          }
        ]
      },
      "language_constant": {
        "patterns": [
          {
            "match": "(?<![^.]\\.|:)\\b(false)\\b",
            "name": "constant.language.boolean.false.luau"
          },
          {
            "match": "(?<![^.]\\.|:)\\b(true)\\b",
            "name": "constant.language.boolean.true.luau"
          },
          {
            "match": "(?<![^.]\\.|:)\\b(nil(?!:))\\b",
            "name": "constant.language.nil.luau"
          }
        ]
      },
      "comment": {
        "patterns": [
          {
            "name": "comment.block.luau",
            "begin": "--\\[(=*)\\[",
            "end": "\\]\\1\\]",
            "patterns": [
              {
                "name": "keyword.operator.other.luau",
                "begin": "(```luau?)\\s*$",
                "while": "^(?!\\s*```)",
                "beginCaptures": {
                  "1": {
                    "name": "comment.luau"
                  }
                },
                "patterns": [
                  {
                    "include": "source.luau"
                  }
                ]
              },
              {
                "match": "(```)",
                "name": "keyword.operator.other.luau",
                "captures": {
                  "1": {
                    "name": "comment.luau"
                  }
                }
              },
              {
                "include": "#doc_comment_tags"
              }
            ]
          },
          {
            "name": "comment.line.double-dash.documentation.luau",
            "begin": "---",
            "end": "\\n",
            "patterns": [
              {
                "include": "#doc_comment_tags"
              }
            ]
          },
          {
            "name": "comment.line.double-dash.luau",
            "begin": "--",
            "end": "\\n"
          }
        ]
      },
      "doc_comment_tags": {
        "patterns": [
          {
            "name": "storage.type.class.luadoc.luau",
            "match": "@\\w+"
          },
          {
            "match": "((?<=[\\s*!\\/])[\\\\@]param)(?:\\s)+(\\b\\w+\\b)",
            "captures": {
              "1": {
                "name": "storage.type.class.luadoc.luau"
              },
              "2": {
                "name": "variable.parameter.luau"
              }
            }
          }
        ]
      },
      "generics-declaration": {
        "begin": "(<)",
        "end": "(>)",
        "patterns": [
          {
            "match": "[a-zA-Z_][a-zA-Z0-9_]*",
            "name": "entity.name.type.luau"
          },
          {
            "match": "=",
            "name": "keyword.operator.assignment.luau"
          },
          {
            "include": "#type_literal"
          }
        ]
      },
      "generics-instantiation": {
        "begin": "(<<)",
        "beginCaptures": {
          "1": {
            "name": "punctuation.definition.typeparameters.begin.luau"
          }
        },
        "end": "(>>)",
        "endCaptures": {
          "1": {
            "name": "punctuation.definition.typeparameters.end.luau"
          }
        },
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#type_literal"
          }
        ]
      },
      "type-function": {
        "begin": "(?<![^.]\\.|:)\\b(?:(export)\\s+)?(type)\\s+(function)\\b",
        "beginCaptures": {
          "1": {
            "name": "storage.modifier.visibility.luau"
          },
          "2": {
            "name": "storage.type.luau"
          },
          "3": {
            "name": "keyword.control.luau"
          }
        },
        "end": "(?<=[\\)\\-{}\\[\\]\"'])",
        "name": "meta.function.luau",
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#generics-declaration"
          },
          {
            "begin": "(\\()",
            "beginCaptures": {
              "1": {
                "name": "punctuation.definition.parameters.begin.luau"
              }
            },
            "end": "(\\))",
            "endCaptures": {
              "1": {
                "name": "punctuation.definition.parameters.end.luau"
              }
            },
            "name": "meta.parameter.luau",
            "patterns": [
              {
                "include": "#comment"
              },
              {
                "match": "\\.\\.\\.",
                "name": "variable.parameter.function.varargs.luau"
              },
              {
                "match": "[a-zA-Z_][a-zA-Z0-9_]*",
                "name": "variable.parameter.function.luau"
              },
              {
                "match": ",",
                "name": "punctuation.separator.arguments.luau"
              },
              {
                "begin": ":",
                "beginCaptures": {
                  "0": {
                    "name": "keyword.operator.type.luau"
                  }
                },
                "end": "(?=[\\),])",
                "patterns": [
                  {
                    "include": "#type_literal"
                  }
                ]
              }
            ]
          },
          {
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b",
            "name": "entity.name.type.luau"
          }
        ]
      },
      "type-alias-declaration": {
        "begin": "(?<![^.]\\.|:)\\b(?:(export)\\s+)?(type)\\b(?=\\s+(?!function\\b)[a-zA-Z_][a-zA-Z0-9_]*)",
        "end": "(?=[),}\\]](?!\\s*[&|]))|(?=\\s*;)|(?=\\s*(?:[*+%^]|\\/\\/?|(?<!\\.)\\.\\.(?!\\.)|-(?![->`])|~=|==))|(?=\\s*\\b(?:and|or|break|const|continue|do|else|elseif|end|for|function|if|in|local|repeat|return|then|until|while)\\b)|(?=^\\s*$)|(?=^\\s*(?:@|\\b(?:export\\s+)?type\\b))|(?=^\\s*[a-zA-Z_][a-zA-Z0-9_]*(?:\\.[a-zA-Z_][a-zA-Z0-9_]*)*\\s*(?:(?:[+\\-*/%^]|\\.\\.)?=(?!=)|\\(|\\[|:))",
        "beginCaptures": {
          "1": {
            "name": "storage.modifier.visibility.luau"
          },
          "2": {
            "name": "storage.type.luau"
          }
        },
        "patterns": [
          {
            "include": "#type_literal"
          },
          {
            "match": "=",
            "name": "keyword.operator.assignment.luau"
          }
        ]
      },
      "type_annotation": {
        "begin": ":(?!\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b(?=\\s*(?:<<|[({\"']|\\[\\[)))",
        "end": "(?<=\\))(?!\\s*->)|=|;|$|(?=\\breturn\\b)|(?=\\bend\\b)",
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#type_literal"
          }
        ]
      },
      "type_cast": {
        "begin": "(::)",
        "beginCaptures": {
          "1": {
            "name": "keyword.operator.typecast.luau"
          }
        },
        "end": "(?=[),}\\]](?!\\s*[&|]))|(?=\\s*;)|(?=\\s*(?:[*+%^]|\\/\\/?|(?<!\\.)\\.\\.(?!\\.)|-(?![->`])|~=|==))|(?=\\s*\\b(?:and|or|break|const|continue|do|else|elseif|end|for|function|if|in|local|repeat|return|then|until|while)\\b)|(?=^\\s*$)|(?=^\\s*(?:@|\\b(?:export\\s+)?type\\b))|(?=^\\s*[a-zA-Z_][a-zA-Z0-9_]*(?:\\.[a-zA-Z_][a-zA-Z0-9_]*)*\\s*(?:(?:[+\\-*/%^]|\\.\\.)?=(?!=)|\\(|\\[|:))",
        "patterns": [
          {
            "include": "#type_literal"
          }
        ]
      },
      "type_literal": {
        "patterns": [
          {
            "include": "#comment"
          },
          {
            "include": "#string"
          },
          {
            "match": "\\?|\\&|\\|",
            "name": "keyword.operator.type.luau"
          },
          {
            "match": "->",
            "name": "keyword.operator.type.function.luau"
          },
          {
            "match": "\\b(false)\\b",
            "name": "constant.language.boolean.false.luau"
          },
          {
            "match": "\\b(true)\\b",
            "name": "constant.language.boolean.true.luau"
          },
          {
            "match": "\\b(nil|any|boolean|buffer|never|number|string|thread|unknown|quaternion|uuid|vector|DetectedEvent|rotation|list|DateTypeArg|DateTypeResult)\\b",
            "name": "support.type.primitive.luau"
          },
          {
            "begin": "\\b(typeof)\\b(\\()",
            "beginCaptures": {
              "1": {
                "name": "support.function.luau"
              },
              "2": {
                "name": "punctuation.arguments.begin.typeof.luau"
              }
            },
            "end": "(\\))",
            "endCaptures": {
              "1": {
                "name": "punctuation.arguments.end.typeof.luau"
              }
            },
            "patterns": [
              {
                "include": "source.luau"
              }
            ]
          },
          {
            "begin": "(<)",
            "end": "(>)",
            "beginCaptures": {
              "1": {
                "name": "punctuation.definition.typeparameters.begin.luau"
              }
            },
            "endCaptures": {
              "1": {
                "name": "punctuation.definition.typeparameters.end.luau"
              }
            },
            "patterns": [
              {
                "match": "=",
                "name": "keyword.operator.assignment.luau"
              },
              {
                "include": "#type_literal"
              }
            ]
          },
          {
            "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b",
            "name": "entity.name.type.luau"
          },
          {
            "begin": "\\{",
            "end": "\\}",
            "patterns": [
              {
                "begin": "\\[",
                "end": "\\]",
                "patterns": [
                  {
                    "include": "#type_literal"
                  }
                ]
              },
              {
                "match": "\\b(?:(read|write)\\s+)?([a-zA-Z_][a-zA-Z0-9_]*)\\b(:)",
                "captures": {
                  "1": {
                    "name": "storage.modifier.access.luau"
                  },
                  "2": {
                    "name": "variable.property.luau"
                  },
                  "3": {
                    "name": "keyword.operator.type.luau"
                  }
                }
              },
              {
                "include": "#type_literal"
              },
              {
                "match": "[,;]",
                "name": "punctuation.separator.fields.type.luau"
              }
            ]
          },
          {
            "begin": "\\(",
            "end": "\\)",
            "patterns": [
              {
                "name": "variable.parameter.luau",
                "match": "\\b([a-zA-Z_][a-zA-Z0-9_]*)\\b(:)",
                "captures": {
                  "1": {
                    "name": "variable.parameter.luau"
                  },
                  "2": {
                    "name": "keyword.operator.type.luau"
                  }
                }
              },
              {
                "include": "#type_literal"
              }
            ]
          }
        ]
      },
      "attribute": {
        "patterns": [
          {
            "name": "meta.attribute.luau",
            "match": "(@)([a-zA-Z_][a-zA-Z0-9_]*)",
            "captures": {
              "1": {
                "name": "keyword.operator.attribute.luau"
              },
              "2": {
                "name": "storage.type.attribute.luau"
              }
            }
          }
        ]
      }
    }
  }